.custom-select:disabled{color:#495057;opacity:1}.custom-select-sm{padding-top:0;padding-bottom:0}
/*# sourceMappingURL=select.component-VAOA4ARB.css.map */
